import React from 'react';

import '../../../styles/containers/Event.css';
import 'react-image-picker/dist/index.css';
import { FormGroup, ControlLabel, Form, Glyphicon } from 'react-bootstrap';
import { AxiosError } from 'axios';

import ImagePicker from '../../utils/FormWidgets/ImagePicker/ImagePicker';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import Rq from '../../utils/FormWidgets/RequireField';
import Succsess from '../../stateMessage/Succsess';
import Error from '../../stateMessage/Error';
import {
  getLocationDescription,
  LocationDescription,
  getDisabledDaysOfWeek,
} from '../../../infrastructure/utils/common';
import { EventParty } from '../../../types/Event';
import { getActivityByCity } from '../../../api/ActivitiesApi';

import TravelForm from './TravelForm';
import AdditionalDetails from './AdditionalDetails';
import LocalEventForm from './LocalEventForm';
import {
  categories as Types,
  newCategories,
  TRAVEL,
  FLIGHT_TRAVEL,
  GROUND_TRAVEL,
  BUS_TRAVEL,
  LODGING_TRAVEL,
} from './EventCategory';
import { getEventByDto, getNewEvent, getEventDto } from './EventManager';

const SECONDS_IN_DAY = 86400;

class State {
  event = null;
  type = null;
  isSuccsess = false;
  isError = false;
  buttonText = '';
  baseImages = false;
  isDeactive = false;
  isNewEvent = true;
  isActivityEvent = false;
  category = '';
  isLodging = false;
  typeNotSelected = true;
  partyMembers = [];
  succsessMessage = '';
  duration = 0;
  disabledDays = [];
  image = '';
  errorMessage = '';
  bookableActivities = [];
  isLoading = false;
}

interface EventFormProps {
  partyMembers: any[];
  event: EventParty;
  offset: number;
  tz: string;
  eventTemplate: any;
  dayForAdd: string;
  typeForCreate: any;
  startDate: Date;
  endDate: Date;
  partyLocation: string;
  images;
}

export class EventForm extends React.Component<EventFormProps> {
  state = new State();

  async componentDidMount() {
    const {
      partyMembers,
      event,
      offset,
      tz,
      eventTemplate,
      partyLocation = '',
    } = this.props;
    const membrs = partyMembers.map(member => ({
      id: member.memberId,
      name: member.memberName,
      status: member.status,
    }));

    if (partyLocation.length) {
      this.setState({ isLoading: true });
      try {
        const bookableActivities = (
          await getActivityByCity(partyLocation, true)
        ).filter(({ bookable }) => bookable);
        this.setState({ bookableActivities, isLoading: false });
      } catch (error) {
        this.setState({ isLoading: false });
      }
    }
    if (event) {
      let estEvent = getEventByDto(event, tz);
      const hours =
        (estEvent.bookingOptions && estEvent.bookingOptions[0].hours) ||
        estEvent.blockingDays;
      if (hours) {
        this.setState({
          disabledDays: getDisabledDaysOfWeek(hours),
        });
      }
      const eventType = Types.find(type => type.Name === estEvent.eventType);
      const type = eventType || Types.find(t => t.Name === 'Things to Do');
      if (
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        type.Name !== 'Travel & Stay' &&
        (!estEvent.eventLocation || !estEvent.eventLocation.address)
      ) {
        estEvent = {
          ...estEvent,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          eventLocation: new LocationDescription(),
        };
      }
      this.setState({
        event: estEvent,
        isNewEvent: false,
        type,
        partyMembers: membrs,
        typeNotSelected: false,
      });
    } else {
      const { dayForAdd, typeForCreate } = this.props;
      let evnt = getNewEvent(dayForAdd, tz, offset, membrs);
      let type = eventTemplate ? eventTemplate.eventType : null;
      if (typeForCreate !== 'Event') {
        type = Types.find(t => t.Name === 'Travel & Stay');
        evnt = {
          ...evnt,
          eventCategory: typeForCreate,
          eventType: 'Travel & Stay',
        };
        if (typeForCreate === 'Flight') {
          evnt = {
            ...evnt,
            eventName: 'Flight',
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            travelType: 'Flight',
            flightType: 'Arriving',
          };
        }
      }
      this.setState({
        event: { ...evnt, ...eventTemplate },
        partyMembers: membrs,
        activityEvent: false,
        type,
      });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  handleChange = ({ target }) => {
    this.setState(prevState => {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      let evnt = { ...prevState.event };
      evnt = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        [target.id]: target.value,
      };
      return { event: evnt };
    });
  };

  handleEventTypeChange = value => {
    this.setState(prevState => {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      let evnt = { ...prevState.event };
      if (value === 'Event') {
        evnt = {
          ...evnt,
          eventType: 'Things to Do',
          eventCategory: 'Other',
        };
      }
      if (value === 'Ground Transportation') {
        evnt = {
          ...evnt,
          eventType: 'Travel & Stay',
          eventCategory: value,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          eventLocationFrom: new LocationDescription(),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          eventLocationTo: new LocationDescription(),
        };
        if (evnt.dateTBD) {
          evnt = {
            ...evnt,
            eventDate: '',
          };
        }
        if (evnt.dateTBD !== evnt.timeTBD) {
          evnt = {
            ...evnt,
            dateTBD: false,
            timeTBD: false,
          };
        }
      }
      const type = Types.find(elem => elem.Name === evnt.eventType);
      return {
        event: evnt,
        type,
        category: value,
        typeNotSelected: false,
      };
    });
  };

  setTBDForTravel = () => {
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        dateTBD: true,
        timeTBD: true,
        startTime: -1,
        endTime: -1,
        eventDate: undefined,
        checkoutDate: undefined,
      };
      return { event };
    });
  };

  switchSecret = val => {
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        isSecret: val,
      };
      return { event };
    });
  };

  placeSelected = async val => {
    if (val.place_id === undefined) {
      return;
    }
    const location = await getLocationDescription(val, true);
    if (val.photos) {
      this.setState(prevstate => {
        const event = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevstate.event,
          eventLocation: location,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          eventName: location.name,
          image: {
            url: val.photos[0].getUrl(),
          },
        };
        return { event };
      });
    } else {
      this.setState(prevstate => {
        const event = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevstate.event,
          eventLocation: location,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          eventName: location.name,
        };
        return { event };
      });
    }
  };

  handleDateChange = value => {
    const { event } = this.state;
    if (
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      (event.eventCategory === 'Lodging' || event.eventCategory === 'Flight') &&
      !value
    ) {
      this.setState(prevState => {
        const evnt = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          startTime: -1,
          endTime: -1,
          eventDate: value,
          checkoutDate: value,
          timeTBD: true,
          dateTBD: true,
        };
        return { event: evnt };
      });
      return;
    }

    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        eventDate: value,
        dateTBD: false,
      };
      return { event };
    });
  };

  switchTBDTime = () => {
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        timeTBD: !prevState.event.timeTBD,
      };
      return { event };
    });
  };

  handleStartTimeChange = value => {
    const { event } = this.state;
    let end = 0;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (event.eventCategory === 'Lodging' || event.eventCategory === 'Flight') {
      if (value === -1) {
        this.setTBDForTravel();
        return;
      }
      this.setState(prevState => {
        const evnt = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          startTime: value,
          timeTBD: false,
          dateTBD: false,
        };
        return { event: evnt };
      });
      return;
    }
    if (value === -1) {
      this.setState(prevState => {
        const evnt = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          startTime: -1,
          endTime: -1,
          timeTBD: true,
        };
        return { event: evnt };
      });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (event.duration > 0) {
      end =
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        value + event.duration * 60 < SECONDS_IN_DAY
          ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            value + event.duration * 60
          : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            value + event.duration * 60 - SECONDS_IN_DAY;
    }
    this.setState(prevState => {
      const evnt = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        startTime: value,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        endTime: end > 0 ? end : prevState.event.endTime,
        timeTBD: false,
      };
      return { event: evnt };
    });
  };

  handleEndTimeChange = value => {
    const { event } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (event.eventCategory === 'Lodging' || event.eventCategory === 'Flight') {
      if (value === -1) {
        this.setTBDForTravel();
        return;
      }
      this.setState(prevState => {
        const evnt = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          endTime: value,
          timeTBD: false,
          dateTBD: false,
        };
        return { event: evnt };
      });
      return;
    }
    if (value === -1) {
      this.setState(prevState => {
        const evnt = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          startTime: -1,
          endTime: -1,
          timeTBD: true,
        };
        return { event: evnt };
      });
      return;
    }
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        endTime: value,
        timeTBD: false,
      };
      return { event };
    });
  };

  handleChangeMembers = ({ target }) => {
    const { event, partyMembers } = this.state;
    const id = target.getAttribute('val');
    let ev = null;
    if (id === 'all') {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const prev = !event.autojoin;
      ev = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...event,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        autojoin: !event.autojoin,
        attendees: prev
          ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            partyMembers.map(member => ({ id: member.id }))
          : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            event.attendees,
      };
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
    } else if (event.attendees.map(att => att.id).indexOf(id) >= 0) {
      ev = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...event,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        attendees: event.attendees.filter(member => member.id !== id),
        autojoin: false,
      };
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.attendees.push(
        partyMembers
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          .map(member => ({ id: member.id }))
          .find(member => member.id === id)
      );
      ev = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...event,
      };
    }
    this.setState({ event: ev });
  };

  handleDataChange = data => {
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        ...data,
      };
      return { event };
    });
  };

  handleImagePicked = image => {
    this.setState(prevState => {
      const event = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.event,
        defaultImageId: image !== '' ? image.value : undefined,
      };
      return { event };
    });
  };

  handleCurrencyChange = ({ target }) => {
    if (target.validity.valid) {
      this.setState(prevState => {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const { costType } = prevState.event;
        const type =
          costType !== null && costType !== undefined ? costType : 'per person';
        const event = {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...prevState.event,
          cost: target.value !== null ? target.value.toString() : '0.00',
          costType: type,
        };
        return { event };
      });
    }
  };

  hideMessage = () => {
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isSuccsess: false, isError: false });
    }
  };

  handleSubmit = async e => {
    e.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleEventSubmit, tz } = this.props;
    const { event, duration } = this.state;
    const utcEvent = getEventDto(event, tz, duration);
    try {
      await handleEventSubmit(utcEvent);
      this.setState({ isSuccsess: true });
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  validateForm() {
    const { event } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (event.eventCategory === LODGING_TRAVEL) {
      const flag =
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.attendees.length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventName &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventName.trim().length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocation.address !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocation.address !== null &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocation.address.trim().length > 0;
      const time =
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventDate !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.checkoutDate !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.startTime !== -1 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.endTime !== -1;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      return event.dateTBD ? flag : time && flag;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (event.eventCategory === FLIGHT_TRAVEL) {
      const flight =
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.travelType && event.travelType === 'Flight'
          ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            event.eventLocationTo !== undefined &&
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            event.eventLocationTo !== null &&
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            event.eventLocationTo.address &&
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            event.eventLocationTo.address.trim().length > 0
          : true;
      const time =
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventDate !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.checkoutDate !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.startTime !== -1 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.endTime !== -1;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const flag = event.dateTBD ? true : time;
      return (
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.attendees.length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address !== null &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address.trim().length > 0 &&
        flight &&
        flag
      );
    }
    if (
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.eventCategory === GROUND_TRAVEL ||
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.eventCategory === BUS_TRAVEL
    ) {
      return (
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.attendees.length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventName &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventName.trim().length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address !== null &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationFrom.address.trim().length > 0 &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationTo.address !== undefined &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationTo.address !== null &&
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.eventLocationTo.address.trim().length > 0
      );
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const validTime = event.timeTBD
      ? true
      : // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        event.startTime !== -1 && event.endTime !== -1;
    return (
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.eventTitle &&
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.eventTitle.trim().length > 0 &&
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      event.attendees.length > 0 &&
      validTime
    );
  }

  render() {
    const {
      startDate,
      endDate,
      typeForCreate,
      partyLocation,
      images,
      tz,
      eventTemplate,
    } = this.props;
    const {
      event,
      isSuccsess,
      isError,
      isNewEvent,
      typeNotSelected,
      partyMembers,
      type,
      disabledDays,
      duration,
      category,
      errorMessage,
      bookableActivities,
      isLoading,
    } = this.state;

    let buttonText = 'Create';
    let succsessMessage = 'Event Created';
    let action = 'Create';
    let evType = 'Event';
    if (!isNewEvent) {
      buttonText = 'Update';
      succsessMessage = 'Event updated';
      action = 'Edit';
    }
    if (
      typeForCreate === 'Flight' ||
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      (event && event.eventCategory === 'Flight')
    ) {
      evType = 'Travel info';
    }
    if (
      typeForCreate === 'Lodging' ||
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      (event && event.eventCategory === 'Lodging')
    ) {
      evType = 'Accommodation info';
    }

    const header = `${action} ${evType}`;

    if (isLoading) {
      return <Glyphicon glyph='refresh' className='spinning' />;
    }

    return (
      event && (
        <section
          className={`${
            typeForCreate === 'Event' && isNewEvent
              ? 'event-form-container'
              : ''
          }`}
        >
          {isSuccsess && <Succsess text={succsessMessage} />}
          {isError && <Error text={errorMessage} />}
          <h4 className='modal-head'>{header}</h4>
          <Form onSubmit={undefined}>
            {isNewEvent && !eventTemplate && typeForCreate === 'Event' && (
              <FormGroup controlId='eventType'>
                <ControlLabel>
                  Type
                  <Rq />
                </ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  placeholder='Type'
                  onChange={this.handleEventTypeChange}
                  value={category}
                  firstEmpty={typeNotSelected}
                  data={newCategories.map(elem => ({
                    value: elem,
                    label: elem,
                  }))}
                />
              </FormGroup>
            )}
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
              // @ts-ignore
              type && type.Name === TRAVEL && (
                <TravelForm
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  event={event}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  TBDTime={event.timeTBD}
                  switchTBDTime={this.switchTBDTime}
                  switchTBD={this.setTBDForTravel}
                  partyLocation={partyLocation}
                  startDate={startDate}
                  endDate={endDate}
                  tz={tz}
                  disabledDays={disabledDays}
                  handleChange={this.handleChange}
                  handleDateChange={this.handleDateChange}
                  handleStartTimeChange={this.handleStartTimeChange}
                  handleEndTimeChange={this.handleEndTimeChange}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  labels={type.Labels.find(
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    elem => elem.Title === event.eventCategory
                  )}
                  handleTravelDataChange={this.handleDataChange}
                  placeSelected={this.placeSelected}
                  duration={duration}
                />
              )
            }
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
              // @ts-ignore
              type && type.Name !== TRAVEL && (
                <LocalEventForm
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  event={event}
                  type={type}
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  TBDTime={event.timeTBD}
                  switchTBDTime={this.switchTBDTime}
                  startDate={startDate}
                  disabledDays={disabledDays}
                  endDate={endDate}
                  tz={tz}
                  handleChange={this.handleChange}
                  placeSelected={this.placeSelected}
                  handleDateChange={this.handleDateChange}
                  handleStartTimeChange={this.handleStartTimeChange}
                  handleEndTimeChange={this.handleEndTimeChange}
                  handleLocalDataChange={this.handleDataChange}
                  duration={duration}
                  isNewEvent={isNewEvent}
                  bookableActivities={bookableActivities}
                />
              )
            }
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
              // @ts-ignore
              ((type && type.Name !== TRAVEL) ||
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                (event.eventCategory !== 'Flight' &&
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  event.eventCategory !== 'Lodging')) && (
                <FormGroup controlId='image'>
                  <ControlLabel>Event Image</ControlLabel>
                  <ImagePicker
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    images={images.map(elem => ({
                      src: elem.url,
                      value: elem.name,
                    }))}
                    selected={
                      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                      // @ts-ignore
                      event.defaultImageId ? event.defaultImageId : undefined
                    }
                    firstSelect={isNewEvent && !eventTemplate}
                    onPick={this.handleImagePicked}
                  />
                </FormGroup>
              )
            }
            <AdditionalDetails
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              event={event}
              switchSecret={this.switchSecret}
              handleChange={this.handleChange}
              handleEventChange={this.handleDataChange}
              handleCurrencyChange={this.handleCurrencyChange}
              partyMembers={partyMembers}
              changeMembers={this.handleChangeMembers}
            />
            <button
              type='button'
              disabled={!this.validateForm()}
              onClick={this.handleSubmit}
              style={{ marginRight: '0px' }}
              className='btn btn-primary pull-right'
            >
              {buttonText}
            </button>
          </Form>
        </section>
      )
    );
  }
}
